module.exports = "/_next/static/images/Delivery-791c832a756e9b141b64b2f0da5e05a7.webp";